import reduce from 'lodash/reduce';
import set from 'lodash/set';
import { useMemo } from 'react';

import { PROFILE_FIELDS_TYPES } from '../../../constants/formFields';

const defaultFields = [
  PROFILE_FIELDS_TYPES.FIRST_NAME,
  PROFILE_FIELDS_TYPES.LAST_NAME,
  PROFILE_FIELDS_TYPES.NAME_SUFFIX,
  PROFILE_FIELDS_TYPES.DOB,
  PROFILE_FIELDS_TYPES.GENDER,
  PROFILE_FIELDS_TYPES.ETHNICITY,
  PROFILE_FIELDS_TYPES.RACE,
];

const defaultValidationFields = [
  PROFILE_FIELDS_TYPES.FIRST_NAME,
  PROFILE_FIELDS_TYPES.LAST_NAME,
  PROFILE_FIELDS_TYPES.DOB,
  PROFILE_FIELDS_TYPES.GENDER,
];

const initialFieldsWithPrivacy = [
  ...defaultFields,
  PROFILE_FIELDS_TYPES.COUNTRY,
];

const validationFieldsWithPrivacy = [
  ...defaultValidationFields,
  PROFILE_FIELDS_TYPES.ACCEPTED_PRIVACY_POLICY,
  PROFILE_FIELDS_TYPES.ACCEPTED_TERMS_AND_CONDITIONS,
];

const useFields = ({ showPrivacy }) => {
  return useMemo(() => {
    let initialFields = defaultFields;
    let validationFields = defaultValidationFields;

    if (showPrivacy) {
      initialFields = initialFieldsWithPrivacy;
      validationFields = [
        ...validationFieldsWithPrivacy,
        PROFILE_FIELDS_TYPES.COUNTRY,
      ];
    }

    const initialState = reduce(
      initialFields,
      (result, value) => set(result, value, ''),
      {},
    );

    return { initialState, initialFields, validationFields };
  }, [showPrivacy]);
};

export default useFields;



// WEBPACK FOOTER //
// ./src/components/Auth/utils/useFields.js